<template>
	<div class="day" @click='selectDay'>
		<div class='number' :class="{inActiveDay: !day.isCurMonth,today:day.isToday,selected:selectedDay.key == day.key}">{{day.date.getDate()}}</div>
		<div class="events">
			<div class="event" @click='selectEvent(event)' :class='{passed:isPassed(day.date,event,serveTime),disabledApplyed: event.RoomStatus.toLowerCase() == "forbid" || day.date.getDay() == 0 ,applyed:event.RoomStatus.toLowerCase() == "otherreserved","self-applyed":event.RoomStatus.toLowerCase() == "myreserved"}' v-for='event in events'>
				<div class="time-slot">{{event.BeginTime}}-{{event.EndTime}}</div>
				<div class="status">{{getRoomStatus(event.RoomStatus,day.date)}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	import {baseMixins} from './baseMixins'
	export default {
		data() {
			return {
			}
		},
		props:{
			day:{
				type:Object,
				default:()=>{}
			},
			selectedDay:{
				type:Object,
				default:()=>{}
			},
			events:{
				type:Array,
				default:()=>[]
			},
			serveTime: {
				type: Date,
				default: () => new Date()
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[baseMixins],
		components: {

		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				
			]),
			async initData(){
			},
			selectDay(){
				this.$emit('selectDay',this.day)
			},
			selectEvent(event) {
				this.$emit('selectEvent',event,this.day)
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/mixin';
	.day {
		width:100%;
		height:100%;
		display:flex;
		flex-direction: column;
		@include fontSize($font-size-16);
		padding:0.1rem;
	}
	.number {
		color: #333;
		align-self: flex-end;
		margin-bottom: 8px;
	}
	.inActiveDay {
		color:#aaa;
	}
	.today {
		background-color:$theme-color;
		width:30px;
		height:30px;
		margin-bottom: 0;
		color:white;
		border-radius: 15px;
		text-align:center;
		line-height: 30px;
	}
	.events {
		margin-top: 10px;
		.event {
			@include fontSize($font-size-14);
			display:flex;
			justify-content: space-between;
			background-color:$green;
			margin-bottom: 10px;
			padding:5px 0.1rem;
			border-radius: 20px;
			color:white;
			cursor: pointer;
		}
		.passed {
			background-color:gray;
			// visibility: hidden;
		}
		.disabledApplyed {
			background-color:gray;
			visibility: visible;
		}
		.self-applyed {
			background-color:$theme-color;
			visibility: visible;
		}
		.applyed {
			background-color: red;
			visibility: visible;
		}

	}
	.sm-events {
		display:none;
	}
	@media (max-width: 768px){
		.day {
			padding:3px;
		}
		.number {
			color: #333;
			align-self: flex-end;
		}
		.inActiveDay {
			color:#aaa;
		}
		.today {
			background-color:$theme-color;
			width:20px;
			height:20px;
			color:white;
			border-radius: 15px;
			text-align:center;
			line-height: 20px;
		}
		.selected {
			border:1px solid $theme-color;
			width:20px;
			height:20px;
			border-radius: 15px;
			text-align:center;
			line-height: 20px;
		}
		.events {
			display:none;
			justify-content: space-around;
			.event {
				padding:5px;
				.time-slot,.status {
					display:none;
				}
			}
		}
		.sm-events {
			display:block;
			margin-top: 0;
			padding:30px 10px;
		}
	}
</style>